import type { PriceSummary } from '@hotjar/webapp/billing/subscription';
import type { SubscriptionSummaryAccount } from '../SubscriptionSummary';
import { ZuoraSubscriptionCosts } from './ZuoraSubscriptionCost';
import { LegacySubscriptionCost } from './LegacySubscriptionCost';

interface Props {
  account: SubscriptionSummaryAccount;
  onSubmit: (x: string) => void;
  hasPaidPlan: boolean;
  zuoraEnabled: boolean;
  subscriptionPriceSummary: PriceSummary | null;
}

export const SubscriptionCost = ({
  account,
  onSubmit,
  hasPaidPlan,
  zuoraEnabled,
  subscriptionPriceSummary,
}: Props): JSX.Element => {
  if (zuoraEnabled) {
    return (
      <ZuoraSubscriptionCosts account={account} onSubmit={onSubmit} hasPaidPlan={hasPaidPlan} />
    );
  }

  return (
    <LegacySubscriptionCost
      account={account}
      onSubmit={onSubmit}
      hasPaidPlan={hasPaidPlan}
      subscriptionPriceSummary={subscriptionPriceSummary}
    />
  );
};

// FIXME: import/no-default-export
// eslint-disable-next-line import/no-default-export
export default SubscriptionCost;

export { Heading } from './SubscriptionCost.styles';
